define("shared/components/shared/credentials/basic-display-status/upgrade", ["exports", "@ember/component", "@ember/debug", "@ember/object", "@ember/service", "@ember/utils", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _debug, _object, _service, _utils, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _dec, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/debug",0,"@ember/object",0,"@ember/service",0,"@ember/utils",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="o--blankWrapper">
    <div class="o--blank">
      <div class={{if @featureImageClass @featureImageClass "img--empty"}}></div>
      {{#if this.needsInstagramProfessional}}
        <h2 class="o--blank__title">
          {{t "shared_phrases.instagram_professional_required.title"}}
        </h2>
        <p>
          {{t "shared_phrases.instagram_professional_required.subtitle" featureName=@featureName}}
        </p>
        <Shared::Link
          @href="https://help.later.com/hc/en-us/articles/360042770474-Switch-to-an-Instagram-Business-or-Creator-Profile"
          @text={{t "shared_phrases.instagram_professional_required.button"}}
          class="o--btn o--btn--outline u--m__t"
          data-test-id="setup-business"
        />
      {{else if this.needsTiktokRefresh}}
        <h2 class="o--blank__title">
          {{t "analytics.tiktok.missing_user_verification.title"}}
        </h2>
        <p class="o--blank__desc">
          {{t "analytics.tiktok.missing_user_verification.subtitle"}}
        </p>
        <div
          class="o--btn o--btn--outline u--m__t"
          data-test-id="connect-business"
          {{on "click" this.refreshTiktokToken}}
        >
          {{t "analytics.tiktok.missing_user_verification.button"}}
        </div>
      {{else if this.needsTiktokPermissions}}
        <h2 class="o--blank__title">
          {{t "analytics.tiktok.missing_user_token.title"}}
        </h2>
        <p class="o--blank__desc">
          {{t "analytics.tiktok.missing_user_token.subtitle"}}
        </p>
        <div
          class="o--btn o--btn--outline u--m__t"
          data-test-id="connect-business"
          {{on "click" this.refreshTiktokToken}}
        >
          {{t "analytics.tiktok.missing_user_token.button"}}
        </div>
      {{else}}
        {{#if this.hasUnconnectedProfessional}}
          <h2 class="o--blank__title">
            {{t "shared_phrases.instagram_professional_required.title"}}
          </h2>
        {{else if (or this.needsInstagramRefresh this.expiredProfessionalToken)}}
          <h2 class="o--blank__title">
            {{t "shared_phrases.refresh_required.title"}}
          </h2>
          {{#if (or this.isAccountOwner this.needsFacebookUserToken)}}
            <p class="o--blank__desc">
              {{t
                "shared_phrases.refresh_required.subtitle"
                featureName=@featureName
                profileName=@socialProfile.displayName
              }}
            </p>
          {{else}}
            <p class="o--blank__desc">
              {{t
                "shared_phrases.refresh_required.team_member_subtitle"
                featureName=@featureName
                profileName=@socialProfile.displayName
              }}
            </p>
          {{/if}}
        {{else}}
          <h2 class="o--blank__title">
            {{t "shared_phrases.missing_user_token.title"}}
          </h2>
          <p class="o--blank__desc">
            {{t "shared_phrases.missing_user_token.subtitle"}}
          </p>
        {{/if}}
        {{#if (or this.isAccountOwner this.needsFacebookUserToken)}}
          <Shared::Credentials::UpgradeButton
            @buttonText={{this.buttonText}}
            @path={{@path}}
            @socialProfile={{@socialProfile}}
            class="u--m__t"
            data-test-id="connect-business"
          />
        {{else}}
          <Shared::Link
            @href="https://help.later.com/hc/articles/360043244093-How-to-Refresh-Your-Social-Profile-Connection"
            class="u--text--sm u--m__b__xs"
          >
            <Shared::Ui::Button @size="regular" @text={{t "shared_phrases.learn_more"}} @variant="outline" />
          </Shared::Link>
        {{/if}}
      {{/if}}
    </div>
  </div>
  */
  {
    "id": "ch2LUUw8",
    "block": "[[[10,0],[14,0,\"o--blankWrapper\"],[12],[1,\"\\n  \"],[10,0],[14,0,\"o--blank\"],[12],[1,\"\\n    \"],[10,0],[15,0,[52,[30,1],[30,1],\"img--empty\"]],[12],[13],[1,\"\\n\"],[41,[30,0,[\"needsInstagramProfessional\"]],[[[1,\"      \"],[10,\"h2\"],[14,0,\"o--blank__title\"],[12],[1,\"\\n        \"],[1,[28,[35,1],[\"shared_phrases.instagram_professional_required.title\"],null]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,2],[12],[1,\"\\n        \"],[1,[28,[35,1],[\"shared_phrases.instagram_professional_required.subtitle\"],[[\"featureName\"],[[30,2]]]]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[8,[39,2],[[24,0,\"o--btn o--btn--outline u--m__t\"],[24,\"data-test-id\",\"setup-business\"]],[[\"@href\",\"@text\"],[\"https://help.later.com/hc/en-us/articles/360042770474-Switch-to-an-Instagram-Business-or-Creator-Profile\",[28,[37,1],[\"shared_phrases.instagram_professional_required.button\"],null]]],null],[1,\"\\n\"]],[]],[[[41,[30,0,[\"needsTiktokRefresh\"]],[[[1,\"      \"],[10,\"h2\"],[14,0,\"o--blank__title\"],[12],[1,\"\\n        \"],[1,[28,[35,1],[\"analytics.tiktok.missing_user_verification.title\"],null]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,2],[14,0,\"o--blank__desc\"],[12],[1,\"\\n        \"],[1,[28,[35,1],[\"analytics.tiktok.missing_user_verification.subtitle\"],null]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[11,0],[24,0,\"o--btn o--btn--outline u--m__t\"],[24,\"data-test-id\",\"connect-business\"],[4,[38,3],[\"click\",[30,0,[\"refreshTiktokToken\"]]],null],[12],[1,\"\\n        \"],[1,[28,[35,1],[\"analytics.tiktok.missing_user_verification.button\"],null]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],[[[41,[30,0,[\"needsTiktokPermissions\"]],[[[1,\"      \"],[10,\"h2\"],[14,0,\"o--blank__title\"],[12],[1,\"\\n        \"],[1,[28,[35,1],[\"analytics.tiktok.missing_user_token.title\"],null]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,2],[14,0,\"o--blank__desc\"],[12],[1,\"\\n        \"],[1,[28,[35,1],[\"analytics.tiktok.missing_user_token.subtitle\"],null]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[11,0],[24,0,\"o--btn o--btn--outline u--m__t\"],[24,\"data-test-id\",\"connect-business\"],[4,[38,3],[\"click\",[30,0,[\"refreshTiktokToken\"]]],null],[12],[1,\"\\n        \"],[1,[28,[35,1],[\"analytics.tiktok.missing_user_token.button\"],null]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],[[[41,[30,0,[\"hasUnconnectedProfessional\"]],[[[1,\"        \"],[10,\"h2\"],[14,0,\"o--blank__title\"],[12],[1,\"\\n          \"],[1,[28,[35,1],[\"shared_phrases.instagram_professional_required.title\"],null]],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],[[[41,[28,[37,4],[[30,0,[\"needsInstagramRefresh\"]],[30,0,[\"expiredProfessionalToken\"]]],null],[[[1,\"        \"],[10,\"h2\"],[14,0,\"o--blank__title\"],[12],[1,\"\\n          \"],[1,[28,[35,1],[\"shared_phrases.refresh_required.title\"],null]],[1,\"\\n        \"],[13],[1,\"\\n\"],[41,[28,[37,4],[[30,0,[\"isAccountOwner\"]],[30,0,[\"needsFacebookUserToken\"]]],null],[[[1,\"          \"],[10,2],[14,0,\"o--blank__desc\"],[12],[1,\"\\n            \"],[1,[28,[35,1],[\"shared_phrases.refresh_required.subtitle\"],[[\"featureName\",\"profileName\"],[[30,2],[30,3,[\"displayName\"]]]]]],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]],[[[1,\"          \"],[10,2],[14,0,\"o--blank__desc\"],[12],[1,\"\\n            \"],[1,[28,[35,1],[\"shared_phrases.refresh_required.team_member_subtitle\"],[[\"featureName\",\"profileName\"],[[30,2],[30,3,[\"displayName\"]]]]]],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]]]],[]],[[[1,\"        \"],[10,\"h2\"],[14,0,\"o--blank__title\"],[12],[1,\"\\n          \"],[1,[28,[35,1],[\"shared_phrases.missing_user_token.title\"],null]],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,2],[14,0,\"o--blank__desc\"],[12],[1,\"\\n          \"],[1,[28,[35,1],[\"shared_phrases.missing_user_token.subtitle\"],null]],[1,\"\\n        \"],[13],[1,\"\\n      \"]],[]]]],[]]],[41,[28,[37,4],[[30,0,[\"isAccountOwner\"]],[30,0,[\"needsFacebookUserToken\"]]],null],[[[1,\"        \"],[8,[39,5],[[24,0,\"u--m__t\"],[24,\"data-test-id\",\"connect-business\"]],[[\"@buttonText\",\"@path\",\"@socialProfile\"],[[30,0,[\"buttonText\"]],[30,4],[30,3]]],null],[1,\"\\n\"]],[]],[[[1,\"        \"],[8,[39,2],[[24,0,\"u--text--sm u--m__b__xs\"]],[[\"@href\"],[\"https://help.later.com/hc/articles/360043244093-How-to-Refresh-Your-Social-Profile-Connection\"]],[[\"default\"],[[[[1,\"\\n          \"],[8,[39,6],null,[[\"@size\",\"@text\",\"@variant\"],[\"regular\",[28,[37,1],[\"shared_phrases.learn_more\"],null],\"outline\"]],null],[1,\"\\n        \"]],[]]]]],[1,\"\\n\"]],[]]],[1,\"    \"]],[]]]],[]]]],[]]],[1,\"  \"],[13],[1,\"\\n\"],[13]],[\"@featureImageClass\",\"@featureName\",\"@socialProfile\",\"@path\"],false,[\"if\",\"t\",\"shared/link\",\"on\",\"or\",\"shared/credentials/upgrade-button\",\"shared/ui/button\"]]",
    "moduleName": "shared/components/shared/credentials/basic-display-status/upgrade.hbs",
    "isStrictMode": false
  });
  let UpgradeComponent = _exports.default = (_dec = (0, _service.inject)('social/instagram-business'), (_class = class UpgradeComponent extends _component2.default {
    get isAccountOwner() {
      return this.auth.currentUserModel?.isAccountOwner;
    }
    get isInstagram() {
      return this.auth.socialProfile?.isInstagram;
    }
    get isTiktok() {
      return this.auth.socialProfile?.isTiktok;
    }
    get hasUnconnectedBusiness() {
      return this.isInstagram && this.instagramBusiness.hasUnconnectedBusiness;
    }
    get needsInstagramProfessional() {
      return this.isInstagram && this.instagramBusiness.needsProfessional;
    }
    get needsTiktokRefresh() {
      return this.isTiktok && this.auth.currentSocialProfile?.needsRefresh;
    }
    get needsTiktokPermissions() {
      return this.isTiktok && !this.auth.currentSocialProfile?.hasTiktokAnalyticsScope;
    }
    get needsInstagramRefresh() {
      return this.isInstagram && this.instagramBusiness.needsRefresh;
    }
    get needsFacebookUserToken() {
      return this.isInstagram && this.instagramBusiness.needsFacebookUserToken;
    }
    get buttonText() {
      if (this.needsFacebookUserToken) {
        return this.intl.t('shared_words.refresh');
      } else if (this.needsInstagramRefresh && this.isAccountOwner) {
        return this.intl.t('shared_words.refresh');
      } else if (this.needsInstagramRefresh) {
        return this.intl.t('shared_phrases.learn_more');
      }
      return '';
    }
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "auth", _descriptor, this);
      _initializerDefineProperty(this, "tiktok", _descriptor2, this);
      _initializerDefineProperty(this, "instagramBusiness", _descriptor3, this);
      _initializerDefineProperty(this, "intl", _descriptor4, this);
      _initializerDefineProperty(this, "router", _descriptor5, this);
      this._verifyAttrs();
    }
    refreshTiktokToken() {
      this.tiktok.refresh(this.auth.currentSocialProfile);
    }
    transitionToSocialSets() {
      this.router.transitionTo('account.groups');
    }
    _verifyAttrs() {
      (false && !((0, _utils.isPresent)(this.args.featureName)) && (0, _debug.assert)('A `@featureName` argument must be provided', (0, _utils.isPresent)(this.args.featureName)));
      (false && !(typeof this.args.featureName === 'string') && (0, _debug.assert)('The `@featureName` argument must be a string', typeof this.args.featureName === 'string'));
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "tiktok", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "instagramBusiness", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "refreshTiktokToken", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "refreshTiktokToken"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "transitionToSocialSets", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "transitionToSocialSets"), _class.prototype)), _class));
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, UpgradeComponent);
});